module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        _vm.updateValue($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label",
    class: {
      active: !_vm.optionTwo
    }
  }, [_vm._v(_vm._s(_vm.labelOne))]), _vm._v(" "), _c('div', {
    staticClass: "switch-icon"
  }, [_c('img', {
    class: {
      right: _vm.optionTwo
    },
    attrs: {
      "src": require("../assets/images/switch-icon.svg")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label",
    class: {
      active: _vm.optionTwo
    }
  }, [_vm._v(_vm._s(_vm.labelTwo))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46c1965b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputSwitch.vue
// module id = 33
// module chunks = 0